<template>
  <v-container fluid style="background-color: #fff;height: 93vh;">
    <div v-if="generatingChart" class="loading-overlay">
      <v-progress-circular indeterminate color="primary" size="48" />
      <span style="margin-top: 12px; color: #437EBE; font-weight: bold; display: block;">Gerando Gráfico...</span>
    </div>
    <v-row dense class="kpi-strip"
      v-if="isKPI">
      <v-col cols="12" sm="6" md="6" lg="3" :class="['kpi-strip__col', { 'kpi-strip__col--fifth': showSplitAverageKpis }]">
        <div class="kpi-mode-switcher" :style="kpiModeSwitcherStyle">
          <div class="kpi-mode-switcher__content">
            <div>
              <span class="kpi-mode-switcher__label">{{ consumptionViewTitle }}</span>
              <p class="kpi-mode-switcher__description">{{ consumptionViewDescription }}</p>
            </div>
            <v-btn-toggle v-model="kpiViewMode" mandatory dense class="kpi-mode-switcher__toggle">
              <v-btn
                v-for="mode in kpiViewModes"
                :key="mode.value"
                :value="mode.value"
                small
                depressed
                :disabled="isKpiModeDisabled(mode.value)"
                :style="getKpiModeButtonStyle(mode.value)"
              >
                {{ mode.text }}
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>
      </v-col>
      <!-- <v-col cols="2.2">
        <KpiSimpleCard title="Média antes da Foz" :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(adjustedAverage)" style="background-color: #DEF6F9;margin: 0px"/>
      </v-col> -->
      <!-- <v-col cols="2.2">
        <KpiSimpleCard title="Meta de economia" :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(unitSelectedDataKPIs.goalPercentage)" style="background-color: #DEF6F9;margin: 0px"/>
      </v-col> -->
      <!-- <v-col cols="2.2">
        <KpiSimpleCard title="Meta de consumo" :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(goalEconomy)" style="background-color: #DEF6F9;margin: 0px"/>
      </v-col> -->
      <v-col cols="12" sm="6" md="6" lg="3" :class="['kpi-strip__col', { 'kpi-strip__col--fifth': showSplitAverageKpis }]">
        <KpiSimpleCard
          title="Consumo registrado"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(recordedConsumption)"
          :subtitle="selectedKpiModeLabel"
          :info="true"
          :infoText="kpiRecordedConsumptionTip"
          :style="kpiCardStyle"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" class="kpi-strip__col" v-if="!showSplitAverageKpis">
        <KpiSimpleCard
          title="Consumo médio"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(averageConsumption)"
          :subtitle="selectedKpiModeLabel"
          :info="true"
          :infoText="kpiAverageConsumptionTip"
          :style="kpiCardStyle"
        />
      </v-col>
      <v-col v-if="showSplitAverageKpis" cols="12" sm="6" md="6" lg="3" class="kpi-strip__col kpi-strip__col--fifth">
        <KpiSimpleCard
          title="Média de água"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(averageWaterConsumption)"
          subtitle="Água"
          :info="true"
          :infoText="kpiAverageWaterConsumptionTip"
          :style="kpiCardStyle"
        />
      </v-col>
      <v-col v-if="showSplitAverageKpis" cols="12" sm="6" md="6" lg="3" class="kpi-strip__col kpi-strip__col--fifth">
        <KpiSimpleCard
          title="Média de Efluentes"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(averageSewerConsumption)"
          subtitle="Efluentes"
          :info="true"
          :infoText="kpiAverageSewerConsumptionTip"
          :style="kpiCardStyle"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" :class="['kpi-strip__col', { 'kpi-strip__col--fifth': showSplitAverageKpis }]">
        <KpiSimpleCard
          title="Total estimado"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(estimatedTotal)"
          :subtitle="selectedKpiModeLabel"
          :info="true"
          :infoText="kpiEstimatedTotalTip"
          :style="kpiCardStyle"
        />
      </v-col>
      <!-- <v-col cols="2.2">
        <KpiTypeCard title="Tipo de consumo" 
          :water="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(consumptionType[0])" 
          :sewer="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(consumptionType[1])" 
          info :infoText="kpiTipGeneral"  
          style="background-color: #E9E9FF;margin: 0px"/>
      </v-col>    -->
    </v-row>

    <v-row no-gutters v-for="(summedGraph, i) in summedGraphs" :key="i + 123">
      <v-col cols="12" style="padding-bottom: 25px; position: relative;">
        <div class="graph-badge-tooltip-wrapper">
          <div class="graph-context-badge" :style="getGraphBadgeStyle('unit')">GRÁFICO DE UNIDADE</div>
          <span class="graph-badge-tooltip">{{ getGraphBadgeTooltip('unit') }}</span>
        </div>
        <ConsumptionBarChart 
          :title="''"
          :subtitle="''"
          :labels="summedGraph.labels"
          :datasets="summedGraph.dataset"
          :average="0"
          :loading="false"
          :show-goal-line="false"
          @export-pdf="startPdf"
          @export-sheet="exportSheets"
        />
      </v-col>
    </v-row>
    <v-row no-gutters v-for="(dataGraphicUnit, i) in unitsDataGraphic" :key="i">
      <v-col cols="12" style="padding-bottom: 25px; position: relative;" >
        <div class="graph-badge-tooltip-wrapper">
          <div class="graph-context-badge" :style="getGraphBadgeStyle('unit')">GRÁFICO DE UNIDADE</div>
          <span class="graph-badge-tooltip">{{ getGraphBadgeTooltip('unit') }}</span>
        </div>
        <div
          v-if="Array.isArray(dataGraphicUnit.tariffChips) && dataGraphicUnit.tariffChips.length"
          class="graph-tariff-chips"
        >
          <span
            v-for="chip in dataGraphicUnit.tariffChips"
            :key="chip"
          >
            <span class="graph-badge-tooltip-wrapper graph-badge-tooltip-wrapper--chip">
              <span class="graph-tariff-chip">
                {{ chip }}
              </span>
              <span class="graph-badge-tooltip">{{ chip }}</span>
            </span>
          </span>
        </div>
        <ConsumptionBarChart
          :title="''"
          :subtitle="''"
          :labels="dataGraphicUnit.labels"
          :datasets="dataGraphicUnit.dataset"
          :average="0"
          :loading="false"
          :show-goal-line="selectedUnitSum.length <= 1"
          @export-pdf="startPdf"
          @export-sheet="exportSheets"
        />
      </v-col>
    </v-row>

    <!-- Gráfico -->

    <v-row v-if="isDataGraphic" no-gutters v-for="(reading, i) in readings" :key="i">
      <v-col
        cols="12"
        :style="{ marginBottom: '15px', height: dynamicHeight, position: 'relative' }"
      >
        <!-- // * Histórico de Consumo -->
        <div class="graph-badge-tooltip-wrapper">
          <div class="graph-context-badge" :style="getGraphBadgeStyle('sector')">GRÁFICO DE SETOR</div>
          <span class="graph-badge-tooltip">{{ getGraphBadgeTooltip('sector') }}</span>
        </div>
        <div class="graph-badge-tooltip-wrapper graph-badge-tooltip-wrapper--secondary">
          <div class="graph-sector-type-badge" :style="getGraphBadgeStyle('sector')">
            {{ getSectorSupplyBadgeText(reading) }}
          </div>
          <span class="graph-badge-tooltip">{{ getSectorSupplyBadgeTooltip(reading) }}</span>
        </div>
        <ConsumptionBarChart 
          :labels="readings[i].labels" 
          :datasets="readings[i].datasets"
          :average="0" 
          :loading="false" 
          :title="''"
          :subtitle="''"
          @export-pdf="startPdf"
          @export-sheet="exportSheets"
        />
        <div v-if="exporting" class="loading-overlay">
          <v-progress-circular indeterminate color="primary" size="48" />
          <span style="margin-top: 12px; color: #437EBE; font-weight: bold; display: block;">Exportando Arquivo...</span>
        </div>
      </v-col>
    </v-row>
    <!-- Fim Gráfico -->

    <!-- Tabela -->
    <v-row class="dashboardData" align="center" justify="center" v-if="isDataTable" style="border-radius: 1rem">

      <v-card class="rounded-xl" style="border-radius: 20px;width:98%;" v-for="(reading, i) in readings_table" :key="i">
        <!-- Loading enquanto os dados estiverem sendo carregados -->
        <v-overlay absolute style="opacity: 0.8" :value="loadingReadings">
          <v-progress-circular indeterminate color="primary" v-if="loadingReadings"></v-progress-circular>
        </v-overlay>

        <v-toolbar color="primary" dark dense style="border-radius: 20px 20px 0px 0px">
          Leitura {{ getResumeData(reading.modemId, 'modemName') }}
        </v-toolbar>

        <!-- Tabela de Consumo -->
        <v-card-text>
          <div style="width:100%;text-align:center; border-radius:1rem; border: gray 1px solid">
            <v-data-table :headers="headers_tabledays" :items="reading.items" class="rounded-1"
              style="border-radius:1rem;" dense>
            </v-data-table>
            <div class="consumption-total-style">
              <span style="color: #696969; font-weight: bold; font-size:larger">Consumo Médio Atual: </span>
              <span style="font-size: larger; margin-left: 1rem; font-weight: bold">{{ (getResumeData(reading.modemId,
                'average')).toFixed(2) }} {{ isCubicMetersSelected ? 'm³' : 'L' }}</span>
            </div>
            <div class="consumption-total-style">
              <span style="color: #696969; font-weight: bold; font-size:larger">Consumo Medido:</span>
              <span style="font-size: larger; margin-left: 1rem; font-weight: bold">{{ getResumeData(reading.modemId,
                'measured_total').toFixed(2) }} {{ isCubicMetersSelected ? 'm³' : 'L' }}</span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-btn v-show="false" small color="primary" text>Baixar Planilha Completa</v-btn>
    </v-row>
    <v-dialog v-model="dialogDownload" max-width="400">
      <v-card>
        <v-card-title class="headline">Salvar Arquivo</v-card-title>
        <v-card-text>
          Clique abaixo para salvar o arquivo.
          <br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a :href="fileLink" download>
            <v-btn color="success" text @click="dialogDownload = false">
              Salvar Arquivo
            </v-btn>
          </a>
          <v-btn color="error" text @click="dialogDownload = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import ConsumptionScriptByTariff from './ConsumptionScriptByTariff.js';
import KpiSimpleCard from '@/components/KPI/KpiSimpleCard.vue';
import KpiTypeCard from '@/components/KPI/KpiTypeCard.vue';

const merged = {
  ...(ConsumptionScriptByTariff || {}),
  components: {
    ...(ConsumptionScriptByTariff.components || {}),
    KpiSimpleCard,
    KpiTypeCard,
  }
};

export default merged;
</script>

<style lang="scss">
.boxChartsAutoHeighFirstLine {
  border: 1px solid #9fa8da75;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: calc(100vh - 64vh);
  min-height: 300px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  padding: 15px;
}

.litte {
  left: 10px;
}

.consumption-total-style {
  display: flex;
  justify-content: center;
  margin: 10px 0px 10px 0px;
}

.date-picker-height {
  height: 450px
}

.style-div {

  display: flex;
  //justify-content: space-evenly;
  justify-content: flex-start;

}

.layout-data-abstract-fields {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.layout-data-abstract {
  background: #1976d2 !important;
  border-radius: 1rem !important;


}

.style-card-city-name {
  background: #3298ed !important;

  text-align: center !important;
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1rem;
  word-break: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  span {
    color: white;
    font-style: italic;
  }
}

.v-divider {
  border-color: white;
  border-width: 0.05rem;
}

.card-style-data-client {
  color: white !important;
  background: #1976d2 !important;
  text-align: center !important;
  border-style: none !important;
  font-size: 1rem !important;
}

.v-text-field-bar-class {
  border-style: none !important;
}

.text-large {
  font-size: 225%;
  font-weight: 500;
}

.cards {
  padding-top: 5px !important;
  padding-bottom: 4px !important;
  padding-left: 15px !important;
  padding-right: 10px !important;
}

.ticketCards {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.cardsLG {
  margin-bottom: 5px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.ticketCardsLG {
  margin-bottom: 5px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.cardsBigger {
  padding-bottom: 4px !important;
  padding-left: 15px !important;
  padding-right: 10px !important;
}

.cardsBiggerLG {
  margin-bottom: 5px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.kpi-strip {
  margin-bottom: 4px;
}

.kpi-strip__col {
  padding-top: 0 !important;
  padding-bottom: 4px !important;
}

@media (min-width: 1264px) {
  .kpi-strip__col--fifth {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

.kpi-mode-switcher {
  display: block;
  height: 100%;
  overflow: hidden;
}

.kpi-mode-switcher__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  height: 100%;
}

.kpi-mode-switcher__content > div:first-child {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
  white-space: nowrap;
  min-height: 14px;
}

.kpi-mode-switcher__label {
  display: inline-block;
  color: #1f3f67;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.1;
}

.kpi-mode-switcher__description {
  margin: 0;
  color: #60758e;
  font-size: 9px;
  line-height: 1.1;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-mode-switcher__toggle {
  background: #f2f6fb;
  border-radius: 10px;
  padding: 3px;
  box-shadow: inset 0 0 0 1px rgba(67, 126, 190, 0.08);
  width: 100%;
  display: flex;
  min-height: 28px;
  height: 28px;
  margin-bottom: 0;
  overflow: hidden;
}

.kpi-mode-switcher__toggle .v-item-group {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 22px;
  height: 22px;
}

.kpi-mode-switcher__toggle .v-btn {
  flex: 1 1 0;
  min-width: 0 !important;
  min-height: 22px !important;
  height: 22px !important;
  font-size: 10px !important;
  line-height: 1 !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.kpi-mode-switcher__toggle .v-btn__content {
  line-height: 1 !important;
}

.graph-context-badge {
  position: static;
  z-index: 3;
  font-size: 11px !important;
  padding: 5px 10px !important;
  letter-spacing: 0.06em !important;
}

.graph-badge-tooltip-wrapper {
  position: absolute;
  top: 10px;
  left: 16px;
  z-index: 3;
  display: inline-flex;
}

.graph-badge-tooltip-wrapper--secondary {
  position: absolute;
  top: 10px;
  left: 176px;
  z-index: 3;
  display: inline-flex;
}

.graph-badge-tooltip-wrapper--chip {
  position: relative;
  top: auto;
  left: auto;
  z-index: 3;
  display: inline-flex;
}

.graph-badge-tooltip {
  display: none;
  min-width: 150px;
  position: absolute;
  left: 50%;
  top: 120%;
  transform: translateX(-50%);
  background: #001532 !important;
  background-color: #001532 !important;
  color: #fff !important;
  padding: 12px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 400;
  white-space: pre-line;
  z-index: 1000;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  border: none;
}

.graph-badge-tooltip-wrapper:hover .graph-badge-tooltip {
  display: block;
}

.graph-badge-tooltip::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 10px 10px 10px;
  border-style: solid;
  border-color: transparent transparent #0A1B2A transparent;
}

.graph-tariff-chips {
  position: absolute;
  top: 10px;
  left: 178px;
  right: 16px;
  z-index: 3;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.graph-sector-type-badge {
  font-size: 11px !important;
  padding: 5px 10px !important;
  letter-spacing: 0.04em !important;
}

.graph-tariff-chip {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #FFF7ED;
  border: 1px solid #F3D2A7;
  color: #9A5A1A;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

@media (max-width: 1400px) {
  .kpi-mode-switcher__content {
    gap: 4px;
  }

  .kpi-mode-switcher__description {
    font-size: 9px;
  }
}

@media (max-width: 960px) {
  .kpi-mode-switcher__description {
    font-size: 8px;
  }

  .graph-tariff-chips {
    left: 16px;
    top: 42px;
  }

  .graph-sector-type-badge {
    position: static;
  }

  .graph-badge-tooltip-wrapper--secondary {
    left: 16px;
    top: 42px;
  }
}

@media (max-width: 600px) {
  .kpi-mode-switcher__label {
    font-size: 11px;
  }

  .kpi-mode-switcher__description {
    display: none;
  }
}
</style>

